module.exports = __webpack_public_path__ + "static/media/reference-slider-6.38f62411.jpg";